<template>
<div class="inner-wrapper add-customer-section">
   <!--<div class="page-title">
     <h1 class="float-left">Product Details</h1>
   </div>-->
    <ProductDetail :productData="productData"  ref="CustomerDetail"></ProductDetail>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import ProductDetail from "../../components/ProductDetails";
export default {
    name: "ProductView",
    components: {
        ProductDetail
    },
    created() {
        this.getProduct();
    },
    data(){
        return {
            productData: {
                artwork:{
                    products:[]
                },
                vendor_cost:null
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading'
        ]),
        getProduct() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('products.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                         this.productData= data.data;
                         this.productData.artwork = data.artwork;
                         this.productData.vendor_cost = data.data.vendor_cost;
                         //console.log("check product ",this.productData);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
